import React, { useState } from 'react';
import BasicModal from '../../../components/BasicModal';
import { translate } from '../../../services/translate';
import FormInput from '../../../components/FormInput';
import Toast from 'react-native-toast-message';
import { ClientError } from '../../../services/central-api/base-service';
import { cameraService } from '../../../services/central-api/cameras';

export interface MaintenanceRequestValues {
    prompt: string;
    msStart: number;
    msFinish: number;
}

interface Props {
    cameraId?: string;
    isModalVisible: boolean;
    setModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
    emergency: boolean;
}

export default function MaintenanceRequestModal({ cameraId, emergency, isModalVisible, setModalVisible }: Props) {
    const [reason, setReason] = useState('');

    async function createMaintenanceRequest(): Promise<void | false> {
        try {
            if (!cameraId) {
                return false;
            }

            if (emergency) {
                await cameraService.createEmergencyMaintenanceRequest(cameraId, { reason });
            } else {
                await cameraService.createMaintenanceRequest(cameraId, { reason });
            }

            onClose();
            Toast.show({
                type: 'sentinelxSuccess',
                text1: translate('requestMaintenanceCreated'),
            });
        } catch (err) {
            if (err instanceof ClientError) {
                Toast.show({
                    type: 'sentinelxError',
                    text1: translate(err.message),
                });
                return false;
            }

            console.error(err);
            Toast.show({
                type: 'sentinelxError',
                text1: translate('unexpectedError'),
            });
            return false;
        }
    }

    function onClose() {
        setModalVisible(false);
        setReason('');
    }

    return (
        <BasicModal
            isModalVisible={isModalVisible}
            setModalVisible={setModalVisible}
            title={emergency ? translate('requestEmergencyMaintenance') : translate('requestMaintenance')}
            width='small'
            mobileHeight='fit'
            cancelButton={{ onClick: onClose }}
            primaryButton={{
                text: translate('toRequest'),
                onClick: createMaintenanceRequest,
                disabled: reason === '',
            }}
        >

            <FormInput
                label={translate('request')}
                placeholder={translate('requestMaintenancePlaceholder')}
                value={reason}
                onChangeText={setReason}
                invalid={(value: string) => {
                    return value == '';
                }}
                multiline
                numberOfLines={4}
            />

        </BasicModal>
    );
}
